var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShape1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 774,
    height: 847,
    viewBox: "0 0 774 847",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1103.54 1208.44C1028.5 1128.32 1017.17 1111.57 973.36 1033.98C962.625 1014.97 946.62 978.69 932.634 934.682C928.441 921.511 924.783 908.52 921.547 895.762C898.511 804.48 907.009 706.982 928.43 612.504C983.093 371.443 881.624 132.93 690.611 40.9775C499.239 -51.1652 262.19 23.7161 130.75 173.689C113.649 193.203 37.2944 285.892 12.6461 395.797C-65.2745 742.796 255.292 930.299 757.949 1108.37C767.728 1111.83 814.557 1126.34 824.53 1129.16L1103.58 1208.44L1103.54 1208.44Z",
    stroke: "black",
    strokeOpacity: 0.49,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape1);
export default __webpack_public_path__ + "static/media/shape1.8e46cfce109ce662456e2d0b9f5b650c.svg";
export { ForwardRef as ReactComponent };